<p-dialog header="Create New Lead" [modal]="true" [(visible)]="dialogVisible"
    [style]="{ width: '40rem', height: '19rem' }">
    <div [formGroup]="createCustomer">
        <div class="flex items-center gap-4 mb-2">
            <label for="groupname" class="font-semibold w-6rem">Group Name</label>
            <input pInputText type="text" id="groupname" formControlName="groupname" class="flex-auto" />

            <div *ngIf="createCustomer.get('groupname')?.invalid && createCustomer.get('groupname')?.touched">
                <small class="p-error">Group Name is required.</small>
            </div>
        </div>

        <div class="flex items-center gap-4 mb-2">
            <label for="recruiterId" class="font-semibold w-6rem">Recruiter</label>
            <app-staff-dropdown formControlName="recruiterId" class="align-self-stretch"
                [options]="staffOptions"></app-staff-dropdown>
        </div>
        <div class="flex items-center gap-4 mb-4">
            <label for="individual" class="font-semibold w-6rem">Individual</label>
            <p-select formControlName="individual" [options]="loadCustomerSize"
                class="align-self-stretch w-full" appendTo="body" ></p-select>
        </div>

        <div class="flex items-center gap-4 mb-4">
            <label for="status" class="font-semibold w-6rem">Status</label>
            <p-select formControlName="status" [options]="recruitingStatus" class="align-self-stretch w-full"
                appendTo="body"></p-select>
        </div>
    </div>

    <ng-template #footer>
        <div class="flex justify-end gap-2">
            <p-button label="Cancel" severity="secondary" (click)="closeDialog()"></p-button>
            <p-button label="Save" (click)="createLead()"></p-button>
        </div>
    </ng-template>
</p-dialog>
